import message from './messages';
import hints from './hints';
import help from './help';
import sensei from './sensei';
import release from './releases';

const tr = {
  min: `es`,
  full_name: `Español`,
  datePickerFirstDay: `1`,
  datePickerFormat: `dd/mm/yy`,
  dateFormat: `DD/MM/YYYY`,
  yyDateFormat: `DD/MM/YY`,
  minDateFormat: `DD/MM`,
  phpMinDateFormat: `d/m`,
  dateTimeFormat: `DD/MM HH:mm`,
  fullDateTimeFormat: `DD/MM/YYYY HH:mm`,
  dateDayFormat: `DD MMMM`,
  monthDateFormat: `DD MMM`,
  fullDateFormat: `DD MMM YYYY`,
  longFullDateFormat: `DD MMMM YYYY`,
  lFullDateFormat: `DD MMMM YYYY`,
  llFullDateFormat: `ddd DD MMMM YYYY`,
  fullNameFormat: `{firstName} {lastName}`,
  weekDays: [
    `Lunes`,
    `Martes`,
    `Miércoles`,
    `Jueves`,
    `Viernes`,
    `Sábado`,
    `Domingo`,
  ],
  message,
  hints,
  help,
  sensei,
  release,
};

export default tr;
